const getCookie = <T>(key: string): T | null => {
  const replace = key.replaceAll(/([$()*+./?[\\\]^{|}])/g, '\\$1');

  const matches = document.cookie.match(
    new RegExp('(?:^|; )' + replace + '=([^;]*)'),
  );

  const result = matches ? decodeURIComponent(matches[1]) : undefined;

  return result ? (JSON.parse(result) as T) : null;
};

const setCookie = (
  name: string,
  value: object | string,
  options: {
    expires?: unknown;
    [key: string]: unknown;
  } = {},
): void => {
  options = {
    path: '/',
    ...options,
  };

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  const stringifyValue =
    typeof value === 'object' ? JSON.stringify(value) : value;

  let updatedCookie =
    encodeURIComponent(name) + '=' + encodeURIComponent(stringifyValue);

  for (const optionKey in options) {
    updatedCookie += '; ' + optionKey;
    const optionValue = options[optionKey];

    if (optionValue !== true) {
      updatedCookie += '=' + String(optionValue);
    }
  }

  document.cookie = updatedCookie;
};

export { getCookie, setCookie };
